import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/main/loading';

export const Route = createFileRoute('/_private/settings/')({
  pendingComponent: Loading,
});
